import "./index.css";
import 'dayjs/locale/de';

/*import "@mantine/core/styles.css";
import '@mantine/dates/styles.css';*/
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "~/App";
import { appRoutes } from "~/constants/appRoutes.ts";
import { IS_DEV } from "~/constants/envConstants";

import initI18n from "./i18n/setup";

initI18n({ debug: false });

async function startDevMocks() {
	// The dev check lets Vite drop the MSW code from the production build.
	if (!IS_DEV) return;
	const { startMocks } = await import("~/mocks/browser");
	await startMocks();
}

startDevMocks().catch(console.error).then(() => {
	ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
		<React.StrictMode>
			<BrowserRouter basename={appRoutes.base().path}>
				<App />
			</BrowserRouter>
		</React.StrictMode>,
	);
});
